module.exports = __webpack_public_path__ + "img/icon-team.2aaa8746.svg";